let referenceGroupGroupingHelper = (function ($) {
	class ReferenceGroupGroupingResult {
		constructor(description, note, noteTooltip) {
			this.description = description;
			this.note = note;
			this.noteTooltip = noteTooltip;
		}

		getDescription() {
			return this.description;
		}

		getNote() {
			return this.note;
		}

		getNoteTooltip() {
			return this.noteTooltip;
		}

		hasTooltip() {
			return this.note !== null;
		}
	}

	/**
	 * @param {{
	 *     id: string,
	 *     code: string,
	 *     name: string
	 * }[]} referenceGroups
	 * @returns {ReferenceGroupGroupingResult}
	 */
	let createReferenceGroupGroupingResult = function (referenceGroups) {
		const MAX_REFERENCE_GROUPS_IN_TOOLTIP_NOTE = 20;
		const MAX_REFERENCE_GROUPS_IN_DESCRIPTION = 2;

		if (referenceGroups.length === 0) {
			return new ReferenceGroupGroupingResult('-', null, null);
		}

		if (referenceGroups.length === 1) {
			return new ReferenceGroupGroupingResult(referenceGroups[0].code, null, null);
		}

		if (referenceGroups.length <= MAX_REFERENCE_GROUPS_IN_DESCRIPTION) {
			return new ReferenceGroupGroupingResult(
				referenceGroups
					.map((item) => item.code)
					.sort()
					.join(', '),
				null,
				null
			);
		}

		return new ReferenceGroupGroupingResult(
			referenceGroups.map((item) => item.code).sort()[0],
			'+' + (referenceGroups.length - 1) + ' RS',
			referenceGroups
				.map((item) => item.code)
				.sort()
				.slice(1, MAX_REFERENCE_GROUPS_IN_TOOLTIP_NOTE + 1)
				.join(', ') + (referenceGroups.length > MAX_REFERENCE_GROUPS_IN_TOOLTIP_NOTE + 1 ? '…' : '')
		);
	};

	return {
		createReferenceGroupGroupingResult: createReferenceGroupGroupingResult,
	};
})(jQuery);

export { referenceGroupGroupingHelper };
